import React from "react";

const REDEMPTION_STATUSES = [
  { value: "", label: "All statuses" },
  { value: "PENDING", label: "Pending" },
  { value: "COMPLETED", label: "Fulfilled" },
  { value: "PARTIALLY_COMPLETED", label: "Partially fulfilled" },
  { value: "REJECTED", label: "Rejected" },
  { value: "CANCELLED", label: "Cancelled" },
];

const TRANSFER_STATUSES = [
  { value: "", label: "All statuses" },
  { value: "PENDING", label: "Pending" },
  { value: "COMPLETED", label: "Fulfilled" },
  { value: "PARTIALLY_COMPLETED", label: "Partially fulfilled" },
  { value: "REJECTED", label: "Cancelled" },
];

export default function InvestorHistoryFilters({
  idPrefix,
  filters,
  onChange,
  projectOptions,
  onApply,
  onReset,
  loading,
  variant = "redemption",
  searchPlaceholder,
}) {
  const statuses = variant === "transfer" ? TRANSFER_STATUSES : REDEMPTION_STATUSES;
  const searchPh =
    searchPlaceholder ||
    (variant === "transfer" ? "Transfer ID or project name" : "Redemption ID or project name");

  return (
    <section className="investor-section">
      <h3 className="investor-section__title">Search &amp; filter</h3>
      <p className="investor-section__desc" style={{ marginBottom: "0.85rem" }}>
        {variant === "transfer"
          ? "Narrow offer history by project, status, or transfer ID."
          : "Narrow request history by project, status, or redemption ID."}
      </p>
      <div className="investor-filters-grid">
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-project`}>Project</label>
          <select
            id={`${idPrefix}-project`}
            value={filters.project_id}
            onChange={(e) => onChange({ project_id: e.target.value, page: 1 })}
          >
            <option value="">All projects</option>
            {projectOptions.map(([id, label]) => (
              <option key={id} value={id}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-status`}>Status</label>
          <select
            id={`${idPrefix}-status`}
            value={filters.status}
            onChange={(e) => onChange({ status: e.target.value, page: 1 })}
          >
            {statuses.map((s) => (
              <option key={s.value || "all"} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-from`}>From date</label>
          <input
            id={`${idPrefix}-from`}
            type="date"
            value={filters.date_from}
            onChange={(e) => onChange({ date_from: e.target.value, page: 1 })}
          />
        </div>
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-to`}>To date</label>
          <input
            id={`${idPrefix}-to`}
            type="date"
            value={filters.date_to}
            onChange={(e) => onChange({ date_to: e.target.value, page: 1 })}
          />
        </div>
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-q`}>Search</label>
          <input
            id={`${idPrefix}-q`}
            placeholder={searchPh}
            value={filters.q}
            onChange={(e) => onChange({ q: e.target.value, page: 1 })}
          />
        </div>
        <div className="investor-filters-grid__field">
          <label htmlFor={`${idPrefix}-sort`}>Sort</label>
          <select
            id={`${idPrefix}-sort`}
            value={filters.sort}
            onChange={(e) => onChange({ sort: e.target.value, page: 1 })}
          >
            <option value="newest">Newest first</option>
            <option value="oldest">Oldest first</option>
            <option value="amount_desc">Highest amount</option>
            <option value="amount_asc">Lowest amount</option>
          </select>
        </div>
      </div>
      <div className="investor-filters-grid__actions">
        <button type="button" className="btn-secondary" onClick={onApply} disabled={loading}>
          {loading ? "Loading…" : "Apply filters"}
        </button>
        <button type="button" className="btn-secondary compact-btn" disabled={loading} onClick={onReset}>
          Reset
        </button>
      </div>
    </section>
  );
}
